export default "__VITE_ASSET__gTnsOBkL__"